import React from 'react';
import moment from 'moment';
import Icon from 'components/Icon';
import DataTable from 'components/DataTable';
import { Button, Tooltip } from 'antd';

const UserType = {
    "1": "OpenID",
    "2": "内部"
};

const UserRole = {
    "1": "管理员",
    "2": "开发者",
    "3": "产品",
    "99": "普通人"
};

const UserRoleHash = {
    "Admin": 1,
    "Dev": 2,
    "Pro": 3,
    "Def": 99
};

const UserColumns = function (self) {
    return [
        {
            title: '用户名',
            name: 'username',
            tableItem: {}
        },
        {
            title: 'EMail',
            name: 'email',
            tableItem: {}
        },
        {
            title: '登录类型',
            name: 'type',
            tableItem: {
                render: (text) => (
                    <span>{UserType[text]}</span>
                )
            }
        },
        {
            title: '用户类型',
            name: 'role',
            tableItem: {
                render: (text) => (
                    <span>{UserRole[text]}</span>
                )
            }
        },
        {
            title: '创建时间',
            name: 'create_time',
            tableItem: {
                render: text => (
                    <>{moment(text).format('YYYY-MM-DD HH:mm:ss')}</>
                )
            }
        },
        {
            title: '操作',
            tableItem: {
                width: 180,
                render: (text, record) => (
                    <DataTable.Oper>
                        <Tooltip title="修改">
                            <Button onClick={() => self.showModifyModel(record)}>
                                <Icon antd={true} type="FormOutlined" />
                            </Button>
                        </Tooltip>
                        {record.can_login ?
                            (
                                <Tooltip title="禁止登录">
                                    <Button onClick={() => self.lockUser(record, 'lock')}>
                                        <Icon antd={true} type="LockOutlined" style={{ color: 'red', fontSize: '16px' }} />
                                    </Button>
                                </Tooltip>
                            )
                            :
                            (
                                <Tooltip title="允许登录">
                                    <Button onClick={() => self.lockUser(record, 'unlock')}>
                                        <Icon antd={true} type="UnlockOutlined" style={{ color: 'green', fontSize: '16px' }} />
                                    </Button>
                                </Tooltip>
                            )
                        }
                    </DataTable.Oper>
                )
            }
        }
    ]
}

export { UserType, UserRole, UserRoleHash, UserColumns };

